import { MenuItem } from "@mui/material"
import { MRT_Row } from "material-react-table"

import { ExternalServiceEntry } from "../extraServicesTypes"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { getExtraServiceRoute } from "../../../../../constants/routes"
import { DefaultConfirmModalStateType } from "./DeleteExtraServiceDialog"

type RenderRowActionMenuItemsProps = {
    row: MRT_Row<ExternalServiceEntry>
    closeMenu: () => void
    setConfirmModalState: React.Dispatch<React.SetStateAction<DefaultConfirmModalStateType>>
    navigate: (path: string) => void
}

export const renderRowActionMenuItems = ({
    row,
    closeMenu,
    setConfirmModalState,
    navigate,
}: RenderRowActionMenuItemsProps) => {
    return [
        <LocalizedStrict id="products-edit-product-menu-item" key={`edit-${row.original.id}`}>
            <MenuItem
                onClick={() => {
                    navigate(getExtraServiceRoute(row.original.id))
                    closeMenu()
                }}
            >
                Edit
            </MenuItem>
        </LocalizedStrict>,
        <LocalizedStrict id="products-delete-product-menu-item" key={`delete-${row.original.id}`}>
            <MenuItem
                onClick={() => {
                    setConfirmModalState({
                        showConfirmModal: true,
                        confirmModalText: `${row.original.name}`,
                        productId: row.original.id,
                    })
                    closeMenu()
                }}
            >
                Delete
            </MenuItem>
        </LocalizedStrict>,
    ]
}
